import '@ankr.com/assets/public/fonts/index.css';
import 'core-js/es/object/from-entries';
import { register as registerSW } from 'serviceWorker/register';
import { createRoot, hydrateRoot } from 'react-dom/client';
// this package is only for debugging in dev mode
// eslint-disable-next-line import/no-extraneous-dependencies
import setupLocatorUI from '@locator/runtime';

import { initializeSentry } from 'modules/sentry';
import { isSSG } from 'modules/common/utils/isSSG';
import { setCanonicalTags, setRobotsTags } from 'uiKit/utils/metatags';
import { ENV_SSR } from 'modules/common/constants/env';
import { featureConfig } from 'modules/common/featureConfig';
// Side-effect import — body is `if (import.meta.env.VITE_E2E_HOOKS === 'true')`
// so the module is dead code (tree-shaken) when the env var is unset. Only
// the e2e build step in .github/workflows/playwright.yml sets it.
import 'modules/api/web3/e2eHooks';

import App from './App';

if (process.env.NODE_ENV === 'development') {
  setupLocatorUI();
}

if (!isSSG()) {
  initializeSentry();
}

setCanonicalTags();
setRobotsTags();

const rootElement = document.getElementById('root');

if (rootElement?.hasChildNodes() && ENV_SSR) {
  hydrateRoot(rootElement, <App />);
} else if (rootElement) {
  createRoot(rootElement).render(<App />);
}

if (!isSSG() && featureConfig.serviceWorker) {
  registerSW();
}
